import { render, staticRenderFns } from "./BatchPassTeam.vue?vue&type=template&id=6f4db4ec"
import script from "./BatchPassTeam.vue?vue&type=script&lang=ts"
export * from "./BatchPassTeam.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports